// ── History client ───────────────────────────────────────────────────────────
// Talks to the shona-reader-history Lambda (through API Gateway; see
// server/lambda/history_handler.py), which keeps a signed-in reader's clips.
// Only the browser's two calls live here; Modal makes the ones that save a clip.
//
//   REACT_APP_SHONA_HISTORY_URL — the API's /history route. Unset = History off.

const HISTORY_URL = process.env.REACT_APP_SHONA_HISTORY_URL;

export const HISTORY_ENABLED = Boolean(HISTORY_URL);

// `status` is the HTTP status, or 0 when the request never got an answer.
export class HistoryError extends Error {
  constructor(status, detail) {
    super(detail);
    this.name = 'HistoryError';
    this.status = status;
  }
}

const request = async (token, path, options = {}) => {
  let res;
  try {
    res = await fetch(`${HISTORY_URL}${path}`, {
      ...options,
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    throw new HistoryError(0, err.message);
  }
  if (!res.ok) throw new HistoryError(res.status, `HTTP ${res.status}`);
  return res;
};

// One page of clips, newest first: { items, nextAfter, retentionDays }.
export const listHistory = async (token, after) => {
  const query = after ? `?after=${encodeURIComponent(after)}` : '';
  const res = await request(token, query);
  return res.json();
};

export const deleteHistory = async (token, clipId) => {
  await request(token, `/${encodeURIComponent(clipId)}`, { method: 'DELETE' });
};

// How long clips are kept, in words, from the API's `retentionDays`.
const DAYS_PER_MONTH = 30.4;

export const retentionText = days => {
  if (days < 28) return `${days} days`;
  const months = Math.round(days / DAYS_PER_MONTH);
  return months === 1 ? '1 month' : `${months} months`;
};

// What a clip is called on its card and in the now-playing bar.
const TITLE_WORDS = 6;

export const clipTitle = text => {
  const words = text.trim().split(/\s+/);
  const title = words.slice(0, TITLE_WORDS).join(' ');
  return words.length > TITLE_WORDS ? `${title}…` : title;
};
